/**
 * HostGuidelinesPage - Community Guidelines for Hosts
 */

import React from 'react';
import { PublicLayout, Container } from '../../components/layout';

export const HostGuidelinesPage: React.FC = () => {
  return (
    <PublicLayout>
      <Container className="py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Community Guidelines</h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              Our community is built on trust, respect, and shared experiences. These guidelines help ensure everyone has a great experience on DARAK.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Be Welcoming</h2>
            <p className="text-gray-600 mb-4">
              Welcome guests from all backgrounds. Discrimination of any kind is not tolerated on our platform.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Communicate Clearly</h2>
            <p className="text-gray-600 mb-4">
              Respond to inquiries promptly and provide clear, accurate information about your property. Good communication leads to better experiences.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Honor Your Commitments</h2>
            <p className="text-gray-600 mb-4">
              Once you accept a booking, honor it. Cancellations disrupt travel plans and hurt your reputation as a host.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Maintain Quality</h2>
            <p className="text-gray-600 mb-4">
              Keep your property clean, safe, and as described in your listing. Provide essential amenities and ensure everything is in working order.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Respect Privacy</h2>
            <p className="text-gray-600 mb-4">
              Give guests their space. Only access the property during their stay if absolutely necessary and with prior notice.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Be Honest</h2>
            <p className="text-gray-600 mb-4">
              Provide accurate photos and descriptions. Don't hide issues or exaggerate features. Honesty builds trust and leads to positive reviews.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Support the Community</h2>
            <p className="text-gray-600 mb-4">
              Share tips about local attractions, restaurants, and experiences. Help guests discover the best of Lebanon.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Report Issues</h2>
            <p className="text-gray-600 mb-4">
              If you encounter any problems or violations of these guidelines, report them to our support team at hello@kodefoundry.com
            </p>
          </div>
        </div>
      </Container>
    </PublicLayout>
  );
};

export default HostGuidelinesPage;
